/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FieldValues, UseFormRegister } from "react-hook-form";
import { Radio, Text, theme } from "@nordcloud/gnui";
import { Role } from "~/generated/graphql";

type Props = {
  role: Role;
  selectedRole: Role;
  setRole: (role: Role) => void;
  label: string;
  description: string;
  register: UseFormRegister<FieldValues>;
};

export function RoleRadio({
  role,
  selectedRole,
  setRole,
  register,
  label,
  description,
}: Props) {
  return (
    <Radio
      labelText={
        <div
          onClick={() => setRole(role)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setRole(role);
            }
          }}
          role="textbox"
          tabIndex={0}
        >
          <span>{label}</span>
          <Text
            color={theme.color.text.text02}
            size="sm"
            style={{ lineHeight: "18px" }}
          >
            {description}
          </Text>
        </div>
      }
      {...register("role", { required: true })}
      value={role}
      checked={selectedRole === role}
      onChange={(e) => setRole(e.target.value as Role)}
    />
  );
}
